module.exports = __webpack_public_path__ + "img/uninstall-gbwhatsapp.de0175b5.webp";